<template>
    
    <div>
        
        <div style="display:flex;flex-direction: row;justify-content: flex-end">
      <div style="display:flex;">
        <span class="span-duty">驾校名称</span>
        <a-select
          allowClear
          showSearch
          placeholder="请选择驾校"
          :filterOption="filterOption"
          style="width:165px;margin-right:16px"
          v-model="drivschid"
        >
          <a-select-option
            :value="item.value"
            v-for="(item,idx) in drivschList"
            :key="idx"
          >{{item.label}}</a-select-option>
        </a-select>
      </div>
      <div style="display:flex;margin-left:10px">
        <span class="span-duty">交易日期</span>
        <a-range-picker
          :ranges="{ Today: [moment(), moment()], 'This Month': [moment(), moment().endOf('month')] }"
          @change="dateChange"
          :format="dateFormat"
          v-model="req_date_format"
          style="width:200px"
        />
      </div>

      <!-- <div style="display:flex;margin-left:10px;align-items:center;margin-right:30px">
        <span style="margin-right:10px">调账标识:</span>
        <a-dropdown>
          <a class="ant-dropdown-link" href="#"><a-icon type="down" /> {{adjuststText}} </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a href="javascript:;" @click="adjustst = 'N';adjuststText='未调账'">未调账</a>
            </a-menu-item>
            <a-menu-item>
              <a href="javascript:;" @click="adjustst = 'Y';adjuststText='已调账'">已调账</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div> -->



      <div style="display:flex;margin-left: 10px">
          <span class="span-duty">调账标识</span>
          <a-select
            allowClear
            showSearch
            placeholder="调账标识"
    
            style="width:165px"
            v-model="adjustst"
          >
            <a-select-option value="N">N-未调账</a-select-option>
            <a-select-option value="Y">Y-已调账</a-select-option>
          </a-select>
        </div>


      <a-button
        type="primary"
        style="margin-left:16px;margin-right:16px"
        icon="search"
        @click="()=>{pagination.current = 1;fetch()}"
      >查询</a-button>
      <a-button type="primary" @click="excel">导出</a-button>
    </div>
     <j-table
      :loading="loading"
      :rowKey="record => record.drivschid"
      :tableColumns="columns"
      :tableData="tableData"
      :pageShow="false"
      v-on:onOrderbyChange="(newOrderby)=>{ orderby = newOrderby;fetch(); }"
      v-on:onPaginationChange="(newPagination)=>{ pagination = newPagination;fetch(); }"
      style="margin-top:20px"
    ></j-table>
    </div>


</template>
<script>
import JTable from "../../components/JTable";
import moment from "moment";
const columns = [
  {
    title: "交易日期",
    dataIndex: "txndate",
    key: "txndate",
    align: "center",
    width: 110,
    fixed: "left"
  },
  {
    title: "驾校名称",
    dataIndex: "drivschshtname",
    key: "drivschshtname",
    align: "center",
    width: 150
  },
  {
    title: "消费笔数",
    dataIndex: "xfcount",
    key: "xfcount",
    align: "center",
    width: 120,
    customRender: function(text) {
      return text == "6002"
        ? "驾校上送"
        : text == "6003"
        ? "合同报送"
        : text == "6004"
        ? "合同终止"
        : text == "6005"
        ? "学时报送"
        : text == "6006"
        ? "学时撤销"
        : text == "6007"
        ? "学时费用预支付"
        : text == "6008"
        ? "科目一费用预支付"
        : text == "6009"
        ? "合同到账状态上送"
        : text;
    }
  },
  {
    title: "消费金额",
    dataIndex: "xfpayamt",
    key: "xfpayamt",
    align: "center",
    width: 150
  },
  {
    title: "消费手续费",
    dataIndex: "xfrateamt",
    key: "xfrateamt",
    align: "center",
    width: 150
  },
  {
    title: "撤销笔数",
    dataIndex: "cancelcount",
    key: "cancelcount",
    align: "center",
    width: 150
  },
  {
    title: "撤销金额",
    dataIndex: "cancelpayamt",
    key: "cancelpayamt",
    align: "center",
    width: 150
  },
  {
    title: "撤销手续费",
    dataIndex: "cancelrateamt",
    key: "cancelrateamt",
    align: "center",
    width: 150
  },
  {
    title: "退货笔数",
    dataIndex: "thcount",
    key: "thcount",
    align: "center",
    width: 150
  },
  {
    title: "退货金额",
    dataIndex: "thpayamt",
    key: "thpayamt",
    align: "center",
    width: 150
  },
  {
    title: "退货手续费",
    dataIndex: "thrateamt",
    key: "thrateamt",
    align: "center",
    width: 150
  },
  {
    title: "差额",
    dataIndex: "rateamt",
    key: "rateamt",
    align: "center",
    width: 150
  }
];
export default {
    name:'DrivschPosPay',
    components: {
    JTable
  },
  data() {
    return {
      loading: false,
      columns,
      drivschid: "",
      busicode: "",
      tableData: [],
      drivschList: [],
      start_req_date: moment().subtract(3,'days').format('YYYYMMDD'),
      end_req_date: moment().format('YYYYMMDD'),
      dateFormat: "YYYY-MM-DD",
      req_date_format: [
        moment(moment().subtract(3,'days'), "YYYY-MM-DD"),
        moment(moment(), "YYYY-MM-DD")
      ],
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10,
        pageSizeOptions: ["10", "20", "50"]
      },

      orderby: "platssn desc",
      adjustst: 'N',
      drivasstid: this.$cache.session.get(this.$marco.constants.KEY_ORG_ID),

    };
  },
  created() {
    this.fetch();
    this.fetchDrivsch();
  },
    methods:{
        excel(){
            const that = this;
            that.$http.post(
                that.$marco.api.posexportExcel,
                null,
                data => {
                    window.location.href = data.url;
                },
                errorDesc => {
                    that.$message.error(errorDesc)
                },
                error => {
                    that.$message.error(error)
                },
                that
            );
        },
        moment,
    dateChange(dates, dateString) {
      this.start_req_date = dateString[0]
        ? moment(dateString[0]).format("YYYYMMDD")
        : "";
      this.end_req_date = dateString[1]
        ? moment(dateString[1]).format("YYYYMMDD")
        : "";
  
    },
    fetchDrivsch() {
      const that = this;
      that.$http.post(
        that.$marco.api.schoolId,
        { drivasstid: that.drivasstid },
        data => {
          this.$log.success("驾校列表" + JSON.stringify(data));
          that.drivschList = [];
          data.map(item => {
            that.drivschList.push({
              label: item.drivschname,
              value: item.drivschid
            });
          });
        },
        errorDesc => {
          this.$log.normal("驾协列表" + JSON.stringify(errorDesc));
        },
        error => {
          this.$log.error("驾协列表" + JSON.stringify(error));
        },
        that
      );
    },
    fetch() {
      const that = this;
      that.tableData = [];
      const reqData = {
        busicode: that.busicode,
        drivschid: that.drivschid,
        orderby: that.orderby,
        beginDate: that.start_req_date,
        endDate: that.end_req_date,
        adjustst: that.adjustst
      };
      window.console.log('111111111111111111111111111')
      window.console.log(reqData)
      that.$http.post(
        that.$marco.api.posPaymentDetails,
        reqData,
        data => {
          // that.tableData = that.tableData.concat(data.pagelist);
          window.console.log('gagagagagagagagaga')
          for(let i of data){
            if(!i.drivschshtname){
              i.drivschshtname = "小计"
            }
            window.console.log(i.drivschshtname)
            that.tableData.push({
              txndate:i.txndate,
              drivschshtname:i.drivschshtname,
              xfcount:i.xfcount,
              xfpayamt:i.xfpayamt,
              xfrateamt:i.xfrateamt,
              cancelcount:i.cancelcount,
              cancelpayamt:i.cancelpayamt,
              cancelrateamt:i.cancelrateamt,
              thcount:i.thcount,
              thpayamt:i.thpayamt,
              thrateamt:i.thrateamt,
              rateamt:i.rateamt,

            })
          }
          that.tableData[that.tableData.length-1].drivschshtname = ''


          that.pagination.total = data.recnum;
          this.$log.success(JSON.stringify(that.tableData));
          window.console.log('success')
        },
        errorDesc => {
          this.$log.normal(JSON.stringify(errorDesc));
          window.console.log('reserr')
        },
        error => {
          this.$log.error(JSON.stringify(error));
          window.console.log('err')
        },
        that
      );
    }
    }
}
</script>
<style>
.span-duty {
  padding: 0 11px;
  font-size: 14px;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.65);
  text-align: center;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  border-right: 0;
  height: 32px;
  font-size: 14px;
  line-height: 1.5;
  display: flex;
  align-items: center;
}


</style>